import React from "react";
import SEO from "../shared/seo";
import Layout from "../components/organisms/layout/layout";
import { ReferenciaContenido } from "../interfaces/ReferenciaContenido";
import LibraryComponents from "../components/templates/libraryComponents";
import EmptyLayout from "../components/organisms/layout/empty-layout";
import GlobalContext from "../contexts/globalContext";
import useLoginGigya from "../shared/hooks/useLoginGigya";

const TemplateOne = (props: any) => {
  const gigyaContext = useLoginGigya();
  const pageContext: any = props.pageContext;
  const pageSlug = props.location.pathname;
  const locationState = props.location.state;

  return (
    <EmptyLayout gigyaContext={gigyaContext}>
      <Layout
        hideHeaderDesktop={false}
        hideHeaderMobile={true}
        isNotRoot={true}
        headboard={pageContext.referenciaCabecera}
      >
        <SEO
          title={pageContext.metaTitulo || pageContext.nombreCategoria}
          lang={"es"}
          slug={pageSlug}
          image={
            pageContext.referenciaCabecera
              ? pageContext.referenciaCabecera.imagenHeader &&
                pageContext.referenciaCabecera.imagenHeader.file.url
              : "www.comfama.com/static/a0866af9b026c390d194992080b6e376/logo_1x1.png"
          }
          description={
            pageContext.metaDescripcion && pageContext.metaDescripcion.raw
              ? JSON.parse(pageContext.metaDescripcion.raw)?.content?.[0]
                  ?.content[0]?.value
              : ""
          }
        />
        <GlobalContext.Consumer>
          {() =>
            pageContext.referenciaContenido.map(
              (value: ReferenciaContenido, index: number) => (
                <section id={"sections" + index} key={index}>
                  <LibraryComponents
                    content={value}
                    categoryName={pageContext.nombreCategoria}
                    location={locationState}
                    gigyaContext={gigyaContext}
                  />
                </section>
              )
            )
          }
        </GlobalContext.Consumer>
        <GlobalContext.Consumer>
          {() =>
            pageContext.referenciaContenido ? (
              pageContext.referenciaContenido.map(
                (value: ReferenciaContenido, index: number) => (
                  <section id={"sections" + index} key={index}>
                    {/* Aquí va tu código para cada elemento */}
                  </section>
                )
              )
            ) : (
              <p>La variable referenciaContenido es null.</p>
            )
          }
        </GlobalContext.Consumer>
      </Layout>
    </EmptyLayout>
  );
};

export default TemplateOne;